export default __webpack_public_path__ + "images/03ed512debe3602c9f7ddf341e389f31.svg";